(function (angular) {
    'use strict';
    angular.module('reporting.dashboards.services')
        .service('uiPageOrder', UiPageOrder);
    UiPageOrder.$inject = [];
    function UiPageOrder() {
        function getPagesInUIOrder(pages) {
            var worksheetIds = [];
            var questionPageIds = [];
            angular.forEach(pages, function (page) {
                if (page.meta && page.meta.sourceId) {
                    questionPageIds.push(page);
                }
                else {
                    worksheetIds.push(page);
                }
            });
            return worksheetIds.concat(questionPageIds);
        }
        function getPageIdsInUIOrder(pages) {
            return _.map(getPagesInUIOrder(pages), '_id');
        }
        return {
            getPages: getPagesInUIOrder,
            getPageIds: getPageIdsInUIOrder
        };
    }
})(angular);
